export default {
  GET_FAQ_DATA_REQUESTED: 'GET_FAQ_DATA_REQUESTED',
  GET_FAQ_DATA_SUCCEEDED: 'GET_FAQ_DATA_SUCCEEDED',
  GET_FAQ_DATA_FAILED: 'GET_FAQ_DATA_FAILED',
};
